import { render, staticRenderFns } from "./PageFixedFooter.vue?vue&type=template&id=01f0c938"
import script from "./PageFixedFooter.vue?vue&type=script&lang=js"
export * from "./PageFixedFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports